module.exports = __webpack_public_path__ + "static/img/jpg.55efd84d.png";